module.exports = __webpack_public_path__ + "media/images/flags/nz-61d33f2a21657d93f32bfc4946358e99.svg";